<h1 class="onboarding-title">
  {{ pageData.title || 'Keep up to date with latest offers and news' }}
</h1>
<div class="onboarding-intro" *ngIf="!pageRetrievalError">
  <app-render-markdown [content]="pageData.intro"></app-render-markdown>
</div>
<div class="onboarding-intro" *ngIf="pageRetrievalError">
  <p>
    Endsleigh is part of the A Plan group of companies. A Plan would like to let
    you know about our products, discounts, rewards and competitions we think
    you'd be interested in.
  </p>

  <p>
    Your information will not be shared with anyone outside the A Plan group of
    companies for marketing purposes.
  </p>
</div>
<div class="onboarding-toggle-container">
  <label for="onboarding-toggle" class="toggle onboarding-toggle-label">
    <span
      class="onboarding-toggle-label-text"
      [style.color]="accepted ? '#0857c3' : '#173f35'"
      >{{
        pageData.onboarding_label || 'Receive latest offers and news via email'
      }}</span
    >
    <span class="switch">
      <input
        [formControl]="checkbox"
        type="checkbox"
        name="onboarding-toggle"
        id="onboarding-toggle"
        class="toggle"
        #onboardingToggle
        (change)="onboardingChange()"
      />
      <span class="slider"></span>
    </span>
  </label>
  <p *ngIf="onboardingUpdateError" class="onboarding-update-error">
    Sorry, there was an error updating your details. Please try again.
  </p>
</div>
